function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Group 4");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "storm---journey",
  strokeWidth: 1,
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "outage-details---desktop-on-the-way",
  transform: "translate(-1103.000000, -624.000000)"
}, React.createElement("g", {
  id: "Group-8",
  transform: "translate(1075.000000, 609.000000)"
}, React.createElement("g", {
  id: "Group-7"
}, React.createElement("g", {
  id: "Group-6",
  transform: "translate(14.000000, 0.000000)"
}, React.createElement("g", {
  id: "Group-2"
}, React.createElement("g", {
  id: "Group-5"
}, React.createElement("g", {
  id: "Group-4",
  transform: "translate(15.476190, 16.071429)"
}, React.createElement("path", {
  d: "M39.0293806,36.3644739 L3.82952009,36.3644739 C2.70385045,36.3644739 1.7874442,35.4631745 1.7874442,34.3572484 C1.7874442,34.0613067 1.85809152,33.7696668 1.99762835,33.4915011 C4.82268415,27.8721789 9.58685826,19.8534232 13.7896205,12.7790675 C16.0042969,9.05114279 18.0960938,5.52963055 19.6132533,2.8443202 C20.3996652,1.45089389 22.4574777,1.45089389 23.2439732,2.8443202 C24.7602121,5.527926 26.8502511,9.04611032 29.0631696,12.7705448 C33.2685268,19.8474979 38.0344587,27.8696627 40.8604353,33.4906082 C41.0008092,33.7696668 41.0714565,34.0613067 41.0714565,34.3572484 C41.0714565,35.4631745 40.1550502,36.3644739 39.0293806,36.3644739 Z M42.46649,32.733059 C42.46649,32.733059 42.46649,32.733059 42.4656529,32.7321661 C39.6125558,27.0571621 34.8297991,19.0078869 30.6103795,11.906502 C28.402567,8.18961621 26.3167969,4.67987345 24.8091797,2.01233909 C24.0976842,0.752516768 22.8333147,0 21.4277344,0 C20.0220703,0 18.7577009,0.752516768 18.0462054,2.01233909 C16.5377511,4.681578 14.4510603,8.19464868 12.2406529,11.9140507 C8.02382812,19.0138122 3.24282924,27.0596783 0.390652902,32.733059 C0.131668527,33.2496178 0,33.7966961 0,34.3572484 C0,36.4186135 1.71688058,38.0952381 3.82792969,38.0952381 L21.4285714,38.0936147 L39.0292132,38.0952381 C41.1402623,38.0952381 42.8571429,36.4186135 42.8571429,34.3572484 C42.8571429,33.7966961 42.7254743,33.2496178 42.46649,32.733059 Z",
  id: "Fill-1"
}), React.createElement("path", {
  d: "M21.3963964,8.33333333 C20.7561654,8.33333333 20.2380952,8.71905862 20.2380952,9.19573779 L20.2380952,26.4432609 C20.2380952,26.9199401 20.7561654,27.3056653 21.3963964,27.3056653 C22.0366274,27.3056653 22.5546976,26.9199401 22.5546976,26.4432609 L22.5546976,9.19573779 C22.5546976,8.71905862 22.0366274,8.33333333 21.3963964,8.33333333",
  id: "Fill-4"
}), React.createElement("path", {
  d: "M22.5546976,31.4112107 C22.5546976,31.9933344 22.0360844,32.4651797 21.3963964,32.4651797 C20.7567084,32.4651797 20.2380952,31.9933344 20.2380952,31.4112107 C20.2380952,30.829087 20.7567084,30.3571429 21.3963964,30.3571429 C22.0360844,30.3571429 22.5546976,30.829087 22.5546976,31.4112107 Z",
  id: "Path"
})))))))));

var SvgIconWarning = function SvgIconWarning(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconWarning, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-warning.30065854.svg";
export { ForwardRef as ReactComponent };